
(function () {
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function findCartForms() { return $$('form[action*="/cart/add"]'); }
  function init(block) {
    if (block.dataset.optInit === '1') return;
    block.dataset.optInit = '1';
    var radios = $$('input[type="radio"][data-opt-bundle]', block);
    var subToggle = $('input[data-opt-sub-toggle]', block);
    radios.forEach(function (r) {
      var vid = (r.getAttribute('data-opt-variant-id') || '').trim();
      if (!vid) {
        var t = r.closest('.opt-tile');
        if (t) t.style.display = 'none';
        if (r.checked) r.checked = false;
      }
    });
    if (!$('input[type="radio"][data-opt-bundle]:checked', block)) {
      var first = $('.opt-tile:not([style*="display: none"]) input[type="radio"][data-opt-bundle]', block);
      if (first) first.checked = true;
    }
    function injectIntoForm(form, name, value, marker) {
      var attr = 'data-opt-injected-' + marker;
      var el = form.querySelector('input[' + attr + '="1"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        el.setAttribute(attr, '1');
        el.setAttribute('data-opt-plan-input', '1');
        form.appendChild(el);
      }
      el.value = value == null ? '' : String(value);
    }
    function syncThemeInputs(variantId, planId, subscribed) {
      var planValue = subscribed && planId ? String(planId) : '';
      findCartForms().forEach(function (form) {
        $$('input[name="id"]', form).forEach(function (i) {
          if (i.getAttribute('data-opt-variant-input') === '1') return;
          if (variantId) i.value = String(variantId);
        });
        $$('input[name="selling_plan"]', form).forEach(function (i) {
          if (i.getAttribute('data-opt-plan-input') === '1') return;
          i.value = planValue;
        });
        injectIntoForm(form, 'selling_plan', planValue, 'plan');
        if (variantId) injectIntoForm(form, 'id', String(variantId), 'id');
      });
    }
    function refresh() {
      $$('.opt-tile', block).forEach(function (t) {
        var r = $('input[type="radio"]', t);
        t.classList.toggle('opt-tile-checked', !!(r && r.checked));
      });
      var subscribed = subToggle ? !!subToggle.checked : true;
      var wrap = subToggle && subToggle.closest('.opt-subscribe');
      if (wrap) wrap.classList.toggle('opt-subscribe-checked', subscribed);
      $$('.opt-price-now', block).forEach(function (el) {
        var v = el.getAttribute(subscribed ? 'data-subscribe' : 'data-onetime');
        if (v) el.textContent = v;
      });
      var checked = $('input[type="radio"][data-opt-bundle]:checked', block);
      if (checked) {
        syncThemeInputs(
          Number(checked.getAttribute('data-opt-variant-id') || '0'),
          Number(checked.getAttribute('data-opt-plan-id') || '0'),
          subscribed
        );
      }
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) refresh(); });
    });
    if (subToggle) subToggle.addEventListener('change', refresh);
    refresh();
    findCartForms().forEach(function (form) {
      if (form.dataset.optHijacked === '1') return;
      form.dataset.optHijacked = '1';
      form.addEventListener('submit', function (e) {
        var checked = $('input[type="radio"][data-opt-bundle]:checked', block);
        if (!checked) return;
        var variantId = Number(checked.getAttribute('data-opt-variant-id') || '0');
        var planId = Number(checked.getAttribute('data-opt-plan-id') || '0');
        var subscribed = subToggle ? !!subToggle.checked : true;
        if (!variantId) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        var btn = form.querySelector('button[type="submit"], [name="add"]');
        if (btn) btn.disabled = true;
        var item = { id: variantId, quantity: 1 };
        if (subscribed && planId) item.selling_plan = planId;
        var items = [item];
        var ebookId = block.dataset.ebookVariantId;
        var checkedTile = checked.closest('.opt-tile');
        if (ebookId && checkedTile && checkedTile.querySelector('.opt-ebook')) {
          items.push({ id: Number(ebookId), quantity: 1 });
        }
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items }),
        }).then(function (r) {
          if (!r.ok) return r.text().then(function (t) { throw new Error(r.status + ': ' + t.slice(0, 200)); });
          window.location = '/cart';
        }).catch(function (err) {
          if (btn) btn.disabled = false;
          alert('Could not add to cart: ' + err.message);
        });
      }, true);
    });
  }
  function bootstrap() { $$('.opt').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootstrap);
  else bootstrap();
  document.addEventListener('shopify:section:load', bootstrap);
  if (typeof window.fetch === 'function' && !window.__optFetchPatched) {
    window.__optFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var isCartAdd = url && /\/cart\/add(\.js)?(\?|$|#)/.test(url);
      if (isCartAdd && init && init.body) {
        try {
          var optInput = document.querySelector('.opt input[data-opt-plan-input="1"]:not([data-opt-injected-plan])');
          var optVar = document.querySelector('.opt input[data-opt-variant-input="1"]');
          var plan = optInput && optInput.value;
          var variantId = optVar && optVar.value;
          var checked = document.querySelector('.opt input[type="radio"][data-opt-bundle]:checked');
          var subToggle = document.querySelector('.opt input[data-opt-sub-toggle]');
          var subscribed = subToggle ? !!subToggle.checked : true;
          var tilePlan = checked && checked.getAttribute('data-opt-plan-id');
          if (tilePlan) plan = subscribed ? tilePlan : '';
          if (checked) variantId = checked.getAttribute('data-opt-variant-id') || variantId;
          init.body = patchBody(init.body, '1', plan, variantId);
        } catch (e) {}
      }
      return origFetch.call(this, input, init);
    };
  }
  function patchBody(body, qty, plan, variantId) {
    if (body instanceof FormData) {
      if (qty != null) body.set('quantity', qty);
      if (plan != null) body.set('selling_plan', plan);
      if (variantId) body.set('id', variantId);
      return body;
    }
    if (typeof body === 'string') {
      var t = body.trim();
      if (t.charAt(0) === '{') {
        try {
          var p = JSON.parse(body);
          if (Array.isArray(p.items)) {
            p.items = p.items.map(function (it) {
              return Object.assign({}, it, {
                id: variantId ? Number(variantId) : it.id,
                quantity: qty != null ? Number(qty) : it.quantity,
                selling_plan: plan ? plan : null,
              });
            });
          } else if (p && typeof p === 'object') {
            if (variantId) p.id = Number(variantId);
            if (qty != null) p.quantity = Number(qty);
            if (plan != null) p.selling_plan = plan || null;
          }
          return JSON.stringify(p);
        } catch (e) { return body; }
      }
      try {
        var sp = new URLSearchParams(body);
        if (qty != null) sp.set('quantity', qty);
        if (plan != null) sp.set('selling_plan', plan);
        if (variantId) sp.set('id', variantId);
        return sp.toString();
      } catch (e) { return body; }
    }
    if (body instanceof URLSearchParams) {
      if (qty != null) body.set('quantity', qty);
      if (plan != null) body.set('selling_plan', plan);
      if (variantId) body.set('id', variantId);
      return body;
    }
    return body;
  }
})();
